/* ============================================================
   Othon Schmitt — Theme JS
   ============================================================ */

(function () {
  function initDrawer() {
    var drawer = document.getElementById('drawer');
    var scrim  = document.getElementById('drawerScrim');
    var opener = document.getElementById('menuOpen');
    var closer = document.getElementById('menuClose');
    if (!drawer || !opener) return;

    function setOpen(open) {
      drawer.classList.toggle('open', open);
      if (scrim) scrim.classList.toggle('open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    opener.addEventListener('click', function () { setOpen(true); });
    if (closer) closer.addEventListener('click', function () { setOpen(false); });
    if (scrim)  scrim.addEventListener('click',  function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    drawer.addEventListener('click', function (e) {
      var trigger = e.target.closest('.drawer-accordion-trigger');
      if (!trigger || !drawer.contains(trigger)) return;
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;
      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) panel.setAttribute('hidden', '');
      else panel.removeAttribute('hidden');
    });
  }

  function initPromoBanner() {
    try {
      if (localStorage.getItem('promoDismissed') === '1') {
        var b = document.getElementById('promoBanner');
        if (b) b.style.display = 'none';
      }
    } catch (e) { /* ignore */ }

    var close = document.querySelector('#promoBanner .promo-close');
    if (close) {
      close.addEventListener('click', function () {
        var b = document.getElementById('promoBanner');
        if (b) b.style.display = 'none';
        try { localStorage.setItem('promoDismissed', '1'); } catch (e) {}
      });
    }
  }

  function initNavMenus() {
    var groups = document.querySelectorAll('.has-mega, .has-dropdown');
    if (!groups.length) return;

    var OPEN_DELAY  = 80;
    var CLOSE_DELAY = 280;

    function panelFor(group) {
      return group.querySelector('.mega-panel, .dropdown-panel');
    }

    function closeAll(except) {
      groups.forEach(function (g) {
        if (g === except) return;
        g.classList.remove('is-open');
        var t = g.querySelector('.nav-link');
        if (t) t.setAttribute('aria-expanded', 'false');
        clearTimeout(g._navOpenTimer);
        clearTimeout(g._navCloseTimer);
      });
    }

    function setOpen(group, open) {
      var trigger = group.querySelector('.nav-link');
      if (!trigger) return;
      clearTimeout(group._navOpenTimer);
      clearTimeout(group._navCloseTimer);
      if (open) {
        closeAll(group);
        group.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        group.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    }

    function scheduleOpen(group) {
      clearTimeout(group._navCloseTimer);
      clearTimeout(group._navOpenTimer);
      group._navOpenTimer = setTimeout(function () { setOpen(group, true); }, OPEN_DELAY);
    }

    function scheduleClose(group) {
      clearTimeout(group._navOpenTimer);
      clearTimeout(group._navCloseTimer);
      group._navCloseTimer = setTimeout(function () { setOpen(group, false); }, CLOSE_DELAY);
    }

    function isInsideMenu(node) {
      if (!node || !node.closest) return false;
      return !!(
        node.closest('.has-mega') ||
        node.closest('.has-dropdown') ||
        node.closest('.mega-panel') ||
        node.closest('.dropdown-panel')
      );
    }

    groups.forEach(function (group) {
      var trigger = group.querySelector('.nav-link');
      var panel   = panelFor(group);
      if (!trigger || !panel) return;

      [group, panel].forEach(function (el) {
        el.addEventListener('mouseenter', function () {
          closeAll(group);
          scheduleOpen(group);
        });
        el.addEventListener('mouseleave', function (e) {
          if (isInsideMenu(e.relatedTarget)) return;
          scheduleClose(group);
        });
      });

      group.addEventListener('focusin', function () { setOpen(group, true); });
      group.addEventListener('focusout', function (e) {
        if (!group.contains(e.relatedTarget)) scheduleClose(group);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('.has-mega.is-open, .has-dropdown.is-open, .has-mega:focus-within, .has-dropdown:focus-within');
      if (!open) return;
      closeAll();
      var active = document.activeElement;
      if (active && open.contains(active)) active.blur();
    });
  }

  function start() {
    initDrawer();
    initPromoBanner();
    initNavMenus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============ Collection filters & sort ============
   Color/region/type: client-side (metafields on cards) — products are not tagged,
   so /collections/x/rouge redirects and does nothing.
   Sort: server-side ?sort_by= (Shopify native).
*/
(function () {
  var filtersAbort = null;
  function initCollectionFilters() {
    // Restartable: the theme editor re-renders the section; drop the previous run's page-wide listeners first.
    if (filtersAbort) filtersAbort.abort();
    filtersAbort = typeof AbortController === 'function' ? new AbortController() : null;
    var on = filtersAbort ? { signal: filtersAbort.signal } : false;
    var grid = document.getElementById('grid');
    var meta = document.getElementById('resultsMeta');
    var toolbar = document.querySelector('[data-collection-toolbar]');
    var sectionRoot = document.querySelector('[data-collection-section]');
    if (!grid) return;

    if (toolbar) toolbar.classList.add('js-on');

    // Spirits pages reuse the first dropdown for the spirit type and keep it in ?type= in the address bar.
    var spiritMode = !!(toolbar && toolbar.getAttribute('data-filter-kind') === 'spirits');
    var colorParam = spiritMode ? 'type' : 'color';

    var collectionBase = (sectionRoot && sectionRoot.getAttribute('data-collection-url')) ||
      window.location.pathname.replace(/\/+$/, '');

    var cardPool = null;
    var cardPoolPromise = null;
    var originalGridHTML = grid.innerHTML;
    // Position of this grid page in the collection (read before the address bar loses ?page=).
    var gridOffset = ((parseInt(new URLSearchParams(window.location.search).get('page'), 10) || 1) - 1) *
      (parseInt((sectionRoot && sectionRoot.getAttribute('data-per-page')) || '24', 10) || 24);
    var paginationEl = document.querySelector('.brand-pagination');

    function currentSort() {
      return new URLSearchParams(window.location.search).get('sort_by') || 'manual';
    }

    function sortParamFromUi(mode) {
      if (mode === 'price-asc') return 'price-ascending';
      if (mode === 'price-desc') return 'price-descending';
      if (mode === 'name') return 'title-ascending';
      return 'manual';
    }

    function uiFromSortParam(param) {
      if (param === 'price-ascending') return 'price-asc';
      if (param === 'price-descending') return 'price-desc';
      if (param === 'title-ascending') return 'name';
      return 'featured';
    }

    function isFiltering() {
      return state.color !== 'all' || state.region !== 'all' || state.type !== 'all';
    }

    function buildCollectionUrl(opts) {
      opts = opts || {};
      var url = new URL(collectionBase, window.location.origin);
      var sort = opts.sort != null ? opts.sort : currentSort();
      if (sort && sort !== 'manual') url.searchParams.set('sort_by', sort);
      var color = opts.color != null ? opts.color : state.color;
      var region = opts.region != null ? opts.region : state.region;
      var type = opts.type != null ? opts.type : state.type;
      if (color && color !== 'all') url.searchParams.set(colorParam, color);
      if (region && region !== 'all') url.searchParams.set('region', region);
      if (!spiritMode && type && type !== 'all') url.searchParams.set('type', type);
      return url;
    }

    function syncUrlParams() {
      var url = buildCollectionUrl();
      var next = url.pathname + url.search;
      var current = window.location.pathname + window.location.search;
      // Push a history entry per filter change so Back un-filters instead of leaving the page.
      if (suppressHistory || next === current) {
        history.replaceState({ osFilter: true }, '', next);
      } else {
        history.pushState({ osFilter: true }, '', next);
      }
    }

    var state = { color: 'all', type: 'all', region: 'all' };
    var suppressHistory = false;
    function syncStateFromUrl() {
      state.color = 'all'; state.type = 'all'; state.region = 'all';
      var params = new URLSearchParams(window.location.search);
      var color = (params.get(colorParam) || '').toLowerCase();
      var region = (params.get('region') || '').toLowerCase();
      var type = spiritMode ? '' : (params.get('type') || '').toLowerCase();
      var colorMap = { rouge: 'red', red: 'red', blanc: 'white', white: 'white', rose: 'rose', other: 'other' };
      var typeMap = { whisky: 'whisky', whiskey: 'whisky', rhum: 'rhum', rum: 'rhum', cognac: 'cognac' };
      if (spiritMode) {
        var spiritKey = typeMap[color] || color;
        if (/^[a-z0-9-]+$/.test(spiritKey) && document.querySelector('#filterPanel .dd-option[data-filter="' + spiritKey + '"]')) {
          state.color = spiritKey;
        }
      } else if (colorMap[color]) state.color = colorMap[color];
      if (region) state.region = region;
      if (typeMap[type]) state.type = typeMap[type];
      else if (type) state.type = type;
    }
    syncStateFromUrl();

    function cardMatches(el) {
      if (state.color !== 'all' && (el.getAttribute('data-color') || '') !== state.color) return false;
      if (state.region !== 'all' && (el.getAttribute('data-region') || '') !== state.region) return false;
      if (state.type !== 'all') {
        var cat = (el.getAttribute('data-cat') || '').toLowerCase();
        if (cat !== state.type && cat.indexOf(state.type) === -1) return false;
      }
      return true;
    }

    function updateCount(n) {
      if (!meta) return;
      var template = (window.themeStrings && window.themeStrings.resultsCount) || '__COUNT__ résultats';
      if (typeof template === 'object' && template) {
        template = (n === 1 ? template.one : template.other) || template.other || '__COUNT__ résultats';
      }
      meta.textContent = String(template).replace(/__COUNT__/g, String(n)).replace(/\{\{\s*count\s*\}\}/g, String(n));
      var live = document.getElementById('screenLive');
      if (live) live.textContent = meta.textContent;
    }

    // Exact counts, faceted: each dropdown counts within the other dropdown's current choice, so an option
    // that would return nothing is hidden. Items come from the light ?view=filter-data feed (every product),
    // or from the loaded cards as a fallback.
    var facetItems = null;
    var filterDataPromise = null;

    // On spirits pages the colour key is the spirit type: the first type collection (in dropdown order) a product is in.
    var spiritTypes = spiritMode ? Array.prototype.map.call(document.querySelectorAll('#filterPanel .dd-option[data-filter]'), function (o) {
      return o.getAttribute('data-filter');
    }).filter(function (v) { return v !== 'all' && v !== 'autres'; }) : [];
    function spiritKeyFor(handles) {
      for (var i = 0; i < spiritTypes.length; i++) {
        if (handles.indexOf(spiritTypes[i]) !== -1) return spiritTypes[i];
      }
      return 'autres';
    }

    function loadFilterData() {
      if (filterDataPromise) return filterDataPromise;
      function fetchPage(n, triesLeft) {
        if (triesLeft == null) triesLeft = 2;
        return fetch(collectionBase + '?view=filter-data&page=' + n, { credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function (t) { return JSON.parse(t); })
          .catch(function (err) {
            if (triesLeft <= 0) throw err;
            return new Promise(function (resolve) { setTimeout(resolve, 600 * (3 - triesLeft)); })
              .then(function () { return fetchPage(n, triesLeft - 1); });
          });
      }
      filterDataPromise = fetchPage(1).then(function (first) {
        var rest = [];
        for (var n = 2; n <= Math.min(20, first.pages || 1); n++) rest.push(fetchPage(n));
        return Promise.all(rest).then(function (more) {
          var items = [];
          [first].concat(more).forEach(function (page) {
            (page.items || []).forEach(function (it) {
              var c = spiritMode ? spiritKeyFor(it[2] || []) : (it[0] || '');
              items.push({ c: c, r: it[1] || '' });
            });
          });
          return items;
        });
      });
      return filterDataPromise;
    }

    function updateFacetCounts() {
      if (!facetItems) return;
      var counts = { color: {}, region: {} };
      var totals = { color: 0, region: 0 };
      facetItems.forEach(function (it) {
        if (state.region === 'all' || it.r === state.region) {
          totals.color++;
          if (it.c) counts.color[it.c] = (counts.color[it.c] || 0) + 1;
        }
        if (state.color === 'all' || it.c === state.color) {
          totals.region++;
          if (it.r) counts.region[it.r] = (counts.region[it.r] || 0) + 1;
        }
      });
      var sheetEl = document.getElementById('filterSheet');
      var sheetOpen = !!(sheetEl && sheetEl.getAttribute('aria-hidden') === 'false');
      // A list the shopper has open: rows must not appear, vanish or move under the pointer.
      function inOpenList(el) {
        return (sheetOpen && sheetEl.contains(el)) || !!el.closest('.dd-panel.open');
      }
      // Which options have bottles anywhere in the collection: a dropdown is hidden only when the whole
      // collection offers a single choice, so picking in one dropdown never removes the other.
      var whole = { color: {}, region: {} };
      facetItems.forEach(function (it) {
        if (it.c) whole.color[it.c] = true;
        if (it.r) whole.region[it.r] = true;
      });
      function setCount(badge, n, inUse, kind, v) {
        badge.textContent = String(n);
        badge.classList.remove('is-estimate');
        var opt = badge.closest('.dd-option, .sheet-option');
        if (!opt) return;
        var els = [opt, opt.closest('li')].filter(Boolean);
        function show(greyed) {   // visible; greyed out and not pickable when greyed
          els.forEach(function (el) { el.classList.remove('is-hidden', 'is-pending', 'is-zero'); el.classList.toggle('is-disabled', greyed); });
          if (greyed) opt.setAttribute('aria-disabled', 'true'); else opt.removeAttribute('aria-disabled');
        }
        if (inUse) return show(false);   // the option currently selected is always shown
        var zero = n === 0;
        if (inOpenList(opt)) {
          // Open list: rows keep their place. A visible row is enabled or greyed in place; a hidden one waits for the list to close.
          var visible = !els.some(function (el) { return el.classList.contains('is-hidden') || el.classList.contains('is-zero'); });
          if (visible) show(zero);
          return;
        }
        // Phone sheet: a row the collection has is greyed, never hidden, when another filter leaves it empty,
        // so resetting a filter brings it back in place.
        if (sheetEl && sheetEl.contains(opt) && v !== 'all' && whole[kind][v]) return show(zero);
        if (!zero) return show(false);
        els.forEach(function (el) { el.classList.add('is-zero'); el.classList.remove('is-pending', 'is-disabled'); });
        opt.removeAttribute('aria-disabled');
      }
      var choices = { color: 0, region: 0 };
      ['color', 'region'].forEach(function (kind) {
        var attr = kind === 'color' ? 'filter' : 'region';
        var current = state[kind];
        document.querySelectorAll('.dd-option[data-' + attr + ']').forEach(function (opt) {
          var v = opt.getAttribute('data-' + attr);
          var n = v === 'all' ? totals[kind] : (counts[kind][v] || 0);
          var badge = opt.querySelector('.dd-count');
          if (badge) setCount(badge, n, v === current, kind, v);
          if (v !== 'all' && whole[kind][v]) choices[kind]++;
        });
        document.querySelectorAll('.sheet-option[data-sheet-target="' + kind + '"]').forEach(function (opt) {
          var v = opt.getAttribute('data-sheet-filter');
          var badge = opt.querySelector('.sheet-count');
          if (badge) setCount(badge, v === 'all' ? totals[kind] : (counts[kind][v] || 0), v === current, kind, v);
        });
      });
      // A dropdown with a single real choice filters nothing: hide it, unless it is in use. While any list in the
      // filter bar is open, nothing there changes size, so the open list cannot shift.
      var barPanelOpen = !!document.querySelector('[data-collection-toolbar] .dd-panel.open');
      [['color', 'filterDropdown', 'sheetColorTrigger'], ['region', 'regionDropdown', 'sheetRegionTrigger']].forEach(function (t) {
        var collapse = choices[t[0]] <= 1 && state[t[0]] === 'all';
        var focused = document.activeElement;
        var dd = document.getElementById(t[1]);
        if (dd && !barPanelOpen) dd.classList.toggle('is-collapsed', collapse && !dd.contains(focused));
        var trig = document.getElementById(t[2]);
        var section = trig && trig.closest('.sheet-section');
        if (section && !sheetOpen) section.classList.toggle('is-collapsed', collapse && !section.contains(focused));
      });
      // No filter left at all: the phone "Filtrer par" button would only open Sort.
      var anyFilter = ['filterDropdown', 'regionDropdown', 'typeNavDropdown'].some(function (id) {
        var el = document.getElementById(id);
        return el && !el.classList.contains('is-collapsed');
      });
      var mobileTrigger = document.querySelector('.filter-mobile-trigger');
      if (mobileTrigger && !sheetOpen && !barPanelOpen) mobileTrigger.classList.toggle('is-collapsed', !anyFilter);
      if (toolbar) toolbar.setAttribute('data-counts-exact', 'true');
    }

    function recountBadges(pool) {
      if (!facetItems) {
        facetItems = pool.map(function (el) {
          return { c: el.getAttribute('data-color') || '', r: el.getAttribute('data-region') || '' };
        });
      }
      updateFacetCounts();
    }

    var gridFallback = false;   // the grid shows incomplete results because part of the collection failed to load
    function dedupeCards(groups) {
      var seen = {};
      var pool = [];
      groups.forEach(function (arr) {
        (arr || []).forEach(function (el) {
          var href = el.getAttribute('href') || '';
          if (seen[href]) return;
          seen[href] = true;
          pool.push(el);
        });
      });
      return pool;
    }

    function loadAllCards() {
      if (cardPool) return Promise.resolve(cardPool);
      if (cardPoolPromise) return cardPoolPromise;

      var count = parseInt((sectionRoot && sectionRoot.getAttribute('data-products-count')) || '0', 10);
      var pages = Math.max(1, Math.ceil(Math.min(count || 1, 5000) / 250));
      var sort = currentSort();
      // One ?view=cards page (250 cards, same order as the grid). Retried twice; a refusal (429) waits as long as asked.
      function fetchPage(page, triesLeft) {
        var url = collectionBase + '?view=cards&page=' + page;
        if (sort && sort !== 'manual') url += '&sort_by=' + encodeURIComponent(sort);
        var waitMs = 0;
        return fetch(url, { credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) {
              var after = parseFloat(r.headers.get('Retry-After') || '');
              if (r.status === 429) waitMs = after > 0 ? Math.min(after * 1000, 8000) : 2500;
              throw new Error('HTTP ' + r.status);
            }
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            if (!doc.querySelector('[data-cards-view]')) throw new Error('not a cards page');
            return Array.prototype.map.call(doc.querySelectorAll('[data-cards-view] .product'), function (el) {
              if (spiritMode) {
                var holder = el.closest('[data-collections]');
                el.setAttribute('data-color', spiritKeyFor(holder ? holder.getAttribute('data-collections').split(' ') : []));
              }
              return el;
            });
          })
          .catch(function (err) {
            if (triesLeft <= 0) throw err;
            return new Promise(function (resolve) { setTimeout(resolve, Math.max(waitMs, 600 * (3 - triesLeft))); })
              .then(function () { return fetchPage(page, triesLeft - 1); });
          });
      }
      var groups = [];
      var missing = 0;
      var fetches = [];
      for (var p = 1; p <= pages; p++) {
        (function (page) {
          fetches.push(fetchPage(page, 2).then(function (arr) { groups[page - 1] = arr; }, function () { missing++; }));
        })(p);
      }

      cardPoolPromise = Promise.all(fetches).then(function () {
        if (missing) {
          // Incomplete: hand back what did load, but keep nothing, so the next try starts fresh.
          cardPoolPromise = null;
          var err = new Error(missing + ' card page(s) failed');
          err.groups = groups.slice();   // keeps the gaps where pages failed
          throw err;
        }
        cardPool = dedupeCards(groups);
        recountBadges(cardPool);
        // A filter that fell back to incomplete results while this was loading gets the full result now.
        if (gridFallback && isFiltering()) {
          suppressHistory = true;
          try { applyClientFilters(); } finally { suppressHistory = false; }
        }
        return cardPool;
      });
      return cardPoolPromise;
    }

    // Start loading the cards as soon as a shopper reaches for a filter, so the result is ready when they pick.
    var hasClientFilters = !!document.querySelector('#filterPanel .dd-option[data-filter], #regionPanel .dd-option[data-region]');
    if (hasClientFilters) ['filterTrigger', 'regionTrigger'].forEach(function (id) {
      var t = document.getElementById(id);
      if (!t) return;
      ['pointerenter', 'focus', 'touchstart'].forEach(function (type) {
        t.addEventListener(type, function () { loadAllCards().catch(function () {}); }, { once: true, passive: true });
      });
    });
    var sheetOpener = document.querySelector('.filter-mobile-trigger');
    if (sheetOpener && hasClientFilters) sheetOpener.addEventListener('click', function () { loadAllCards().catch(function () {}); }, { once: true });

    function removeLoadNotice() {
      var n = document.querySelector('[data-filter-load-notice]');
      if (!n) return;
      if (n.contains(document.activeElement) && meta) {   // do not drop keyboard focus to the page
        meta.setAttribute('tabindex', '-1');
        meta.focus();
      }
      n.remove();
    }
    // Translations arrive HTML-escaped (n&#39;ont); decode them before using them as plain text.
    function plainText(str) {
      var el = document.createElement('textarea');
      el.innerHTML = str;
      return el.value;
    }
    function showLoadNotice() {
      var t = window.themeStrings || {};
      var text = plainText(t.filterLoadFailed || 'Some bottles could not be loaded, so these results may be incomplete.');
      // Screen readers: announce through the page's live region (a freshly inserted one is often missed).
      var live = document.getElementById('screenLive');
      if (live) live.textContent = (meta ? meta.textContent + ' — ' : '') + text;
      var existing = document.querySelector('[data-filter-load-notice]');
      if (existing) {   // a retry failed again: update in place so focus stays on the button
        existing.removeAttribute('aria-busy');
        var b = existing.querySelector('[data-filter-retry]');
        if (b) b.removeAttribute('aria-disabled');
        return;
      }
      var n = document.createElement('div');
      n.className = 'filter-load-notice';
      n.setAttribute('data-filter-load-notice', '');
      var msg = document.createElement('span');
      msg.textContent = text;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-filter-retry', '');
      btn.textContent = plainText(t.filterRetry || 'Try again');
      n.appendChild(msg);
      n.appendChild(btn);
      grid.parentNode.insertBefore(n, grid);
    }

    function renderCards(matched) {
      grid.innerHTML = '';
      matched.forEach(function (el) {
        grid.appendChild(el.cloneNode(true));
      });
      if (!matched.length) {
        var ts2 = window.themeStrings || {};
        var es = document.createElement('div');
        es.className = 'empty-state empty-state--filtered';
        es.innerHTML = '<div class="icon">◇ ◇ ◇</div><h2>' + (ts2.emptyFilteredHeading || 'No bottles match') + '</h2>' +
          '<p>' + (ts2.emptyFilteredBody || '') + '</p>' +
          '<div class="empty-actions"><button type="button" class="btn-primary" data-clear-filters>' + (ts2.clearAll || 'Clear all') + '</button></div>';
        grid.appendChild(es);
      }
      updateCount(matched.length);
      if (paginationEl) paginationEl.style.display = 'none';
      grid.classList.remove('loading');
    }

    var filterRun = 0;
    function applyClientFilters(opts) {
      var run = ++filterRun;
      gridFallback = false;
      var notice = document.querySelector('[data-filter-load-notice]');
      if (opts && opts.retry && notice && isFiltering()) {
        notice.setAttribute('aria-busy', 'true');
        var rb = notice.querySelector('[data-filter-retry]');
        if (rb) rb.setAttribute('aria-disabled', 'true');
      } else {
        removeLoadNotice();
      }
      syncUrlParams();
      renderActiveFilters();
      updateActiveCount();
      syncSheetUi();
      updateFacetCounts();

      if (!isFiltering()) {
        grid.innerHTML = originalGridHTML;
        grid.classList.remove('loading');
        if (paginationEl) paginationEl.style.display = '';
        var baseCount = (sectionRoot && sectionRoot.getAttribute('data-products-count')) || grid.querySelectorAll('.product').length;
        updateCount(baseCount);
        return;
      }

      grid.classList.add('loading');
      loadAllCards()
        .then(function (pool) {
          if (run !== filterRun) return;
          renderCards(pool.filter(cardMatches));
          removeLoadNotice();
        })
        .catch(function (err) {
          if (run !== filterRun) return;
          // Part of the collection failed to load: show what did load (plus this page's cards), say so, offer a retry.
          var holder = document.createElement('div');
          holder.innerHTML = originalGridHTML;
          var pagePool = Array.prototype.slice.call(holder.querySelectorAll('.product'));
          // Put this page's cards where they belong (the 250-card slot or slots it spans), so the order holds.
          var gs = (err && err.groups) ? err.groups.slice() : [];
          var s0 = Math.floor(gridOffset / 250);
          var s1 = Math.floor((gridOffset + Math.max(pagePool.length, 1) - 1) / 250);
          var slot = !gs[s0] ? s0 : (!gs[s1] ? s1 : -1);
          if (slot >= 0) gs[slot] = pagePool; else gs.push(pagePool);
          renderCards(dedupeCards(gs).filter(cardMatches));
          gridFallback = true;
          showLoadNotice();
        });
    }

    function setFilterValue(stateKey, val, valueEl, opt) {
      state[stateKey] = val || 'all';
      if (valueEl && opt) {
        var clone = opt.cloneNode(true);
        var countNode = clone.querySelector('.dd-count');
        if (countNode) countNode.remove();
        valueEl.textContent = clone.textContent.trim();
      }
      applyClientFilters();
    }

    function wireDropdown(triggerId, panelId, valueId, stateKey) {
      var trigger = document.getElementById(triggerId);
      var panel = document.getElementById(panelId);
      var valueEl = document.getElementById(valueId);
      if (!trigger || !panel) return;

      function setOpen(open) {
        var wasOpen = panel.classList.contains('open');
        trigger.classList.toggle('open', open);
        panel.classList.toggle('open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (wasOpen && !open) updateFacetCounts();   // rows held still while open can now settle
      }

      document.addEventListener('click', function (e) {
        var opt = e.target.closest('.dd-option');
        if (opt && panel.contains(opt)) {
          if (opt.getAttribute('aria-disabled') === 'true') return;
          panel.querySelectorAll('.dd-option').forEach(function (o) {
            o.classList.remove('active');
          });
          opt.classList.add('active');
          var val = opt.dataset.filter || opt.dataset.region || opt.dataset.type || 'all';
          setOpen(false);
          trigger.focus();
          setFilterValue(stateKey, val, valueEl, opt);
          return;
        }
        if (e.target.closest('#' + triggerId)) {
          setOpen(!panel.classList.contains('open'));
          return;
        }
        if (!panel.contains(e.target)) setOpen(false);
      }, on);
    }

    wireDropdown('filterTrigger', 'filterPanel', 'filterValue', 'color');
    wireDropdown('regionTrigger', 'regionPanel', 'regionValue', 'region');
    wireDropdown('typeTrigger', 'typePanel', 'typeValue', 'type');

    // Spirit type pages (Whisky, Rhum…): the dropdown is a menu of links to the other types.
    (function wireTypeNav() {
      var trigger = document.getElementById('typeNavTrigger');
      var panel = document.getElementById('typeNavPanel');
      if (!trigger || !panel) return;
      function setOpen(open) {
        var wasOpen = panel.classList.contains('open');
        trigger.classList.toggle('open', open);
        panel.classList.toggle('open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (wasOpen && !open) updateFacetCounts();
      }
      document.addEventListener('click', function (e) {
        if (e.target.closest('#typeNavTrigger')) { setOpen(!panel.classList.contains('open')); return; }
        if (!panel.contains(e.target)) setOpen(false);
      }, on);
    })();

    document.querySelectorAll('#chips .chip').forEach(function (chip) {
      // Collection chips are real links — let the browser navigate.
      if (chip.tagName === 'A') return;
      chip.addEventListener('click', function () {
        document.querySelectorAll('#chips .chip').forEach(function (c) {
          c.classList.remove('active');
        });
        chip.classList.add('active');
        state.type = chip.dataset.filter || 'all';
        applyClientFilters();
      });
    });

    var ts = window.themeStrings || {};
    var FILTERS = [
      { panel: 'filterPanel', value: 'filterValue', cat: ts.filterCatColor || 'Filter', key: 'color', dataAttr: 'filter' },
      { panel: 'typePanel', value: 'typeValue', cat: ts.filterCatType || 'Filter', key: 'type', dataAttr: 'type' },
      { panel: 'regionPanel', value: 'regionValue', cat: ts.filterCatRegion || 'Region', key: 'region', dataAttr: 'region' }
    ];

    function updateActiveCount() {
      var n = 0;
      if (state.color !== 'all') n++;
      if (state.type !== 'all') n++;
      if (state.region !== 'all') n++;
      var badge = document.querySelector('[data-active-filter-count]');
      if (badge) {
        if (n > 0) {
          badge.textContent = String(n);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
    }

    function renderActiveFilters() {
      var strip = document.querySelector('.active-filters');
      if (!strip) {
        strip = document.createElement('div');
        strip.className = 'active-filters';
        var gw = document.querySelector('.grid-wrap');
        if (gw) gw.parentNode.insertBefore(strip, gw);
      }
      strip.innerHTML = '';
      var active = [];

      FILTERS.forEach(function (f) {
        var panelEl = document.getElementById(f.panel);
        if (!panelEl) return;
        var opt = panelEl.querySelector('.dd-option.active');
        if (!opt) return;
        var filterVal = opt.dataset[f.dataAttr];
        if (!filterVal || filterVal === 'all') return;
        var labelEl = opt.querySelector('span');
        var label = labelEl
          ? labelEl.textContent.trim().replace(/\s+\d+$/, '')
          : '';
        active.push({ f: f, opt: opt, label: label, panelEl: panelEl });
      });

      if (!active.length) {
        updateActiveCount();
        return;
      }

      var labelNode = document.createElement('span');
      labelNode.className = 'label';
      labelNode.textContent =
        (window.themeStrings && window.themeStrings.activeLabel) || 'Active filters';
      strip.appendChild(labelNode);

      active.forEach(function (a) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'filter-pill';
        pill.innerHTML =
          '<span class="pill-cat">' +
          a.f.cat +
          '</span><span>' +
          a.label +
          '</span><span class="x" aria-label="Remove">×</span>';
        pill.addEventListener('click', function () {
          var allOpt = a.panelEl.querySelector(
            '.dd-option[data-' + a.f.dataAttr + '="all"]'
          );
          if (allOpt) allOpt.click();
        });
        strip.appendChild(pill);
      });

      if (active.length >= 2) {
        var clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'clear-all';
        clear.textContent =
          (window.themeStrings && window.themeStrings.clearAll) || 'Clear all';
        clear.addEventListener('click', clearAllFilters);
        strip.appendChild(clear);
      }
      updateActiveCount();
    }

    function clearAllFilters() {
          state.color = 'all';
          state.type = 'all';
          state.region = 'all';
          FILTERS.forEach(function (f) {
            var panelEl = document.getElementById(f.panel);
            if (!panelEl) return;
            panelEl.querySelectorAll('.dd-option').forEach(function (o) {
              o.classList.toggle('active', (o.dataset[f.dataAttr] || 'all') === 'all');
            });
            var valueEl = document.getElementById(f.value);
            var allOpt = panelEl.querySelector('.dd-option[data-' + f.dataAttr + '="all"]');
            if (valueEl && allOpt) {
              var clone = allOpt.cloneNode(true);
              var countNode = clone.querySelector('.dd-count');
              if (countNode) countNode.remove();
              valueEl.textContent = clone.textContent.trim();
            }
          });
          document.querySelectorAll('#chips .chip').forEach(function (chip) {
            chip.classList.toggle('active', (chip.dataset.filter || 'all') === 'all');
          });
          syncSheetUi();
          applyClientFilters();
    }

    function syncSheetUi() {
      var sheet = document.getElementById('filterSheet');
      if (!sheet) return;
      [['color', state.color, '[data-sheet-color-label]', 'filterValue'], ['region', state.region, '[data-sheet-region-label]', 'regionValue']].forEach(function (t) {
        sheet.querySelectorAll('[data-sheet-target="' + t[0] + '"]').forEach(function (btn) {
          btn.classList.toggle('active', btn.dataset.sheetFilter === t[1]);
        });
        var label = document.querySelector(t[2]);
        var valueEl = document.getElementById(t[3]);
        if (label && valueEl) label.textContent = valueEl.textContent.trim();
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-clear-filters]')) clearAllFilters();
      var retry = e.target.closest('[data-filter-retry]');
      if (retry && retry.getAttribute('aria-disabled') !== 'true') applyClientFilters({ retry: true });
    }, on);

    function navigateWithSort(uiMode) {
      cardPool = null;
      cardPoolPromise = null;
      var url = buildCollectionUrl({ sort: sortParamFromUi(uiMode) });
      window.location.href = url.pathname + url.search;
    }

    function applySort(value, label) {
      var sortSelect = document.getElementById('collectionSort');
      var sortDisplay = document.querySelector('[data-sort-value-display]');
      var sortPanel = document.getElementById('sortPanel');
      if (sortSelect) sortSelect.value = value;
      if (sortDisplay && label) sortDisplay.textContent = label;
      if (sortPanel) {
        sortPanel.querySelectorAll('.sort-option').forEach(function (opt) {
          var on = opt.dataset.sortValue === value;
          opt.setAttribute('aria-selected', on ? 'true' : 'false');
          var check = opt.querySelector('.sort-check');
          if (check) check.textContent = on ? '✓' : '';
        });
      }
      document.querySelectorAll('.sheet-sort-option').forEach(function (opt) {
        var on = opt.dataset.sortValue === value;
        opt.setAttribute('aria-checked', on ? 'true' : 'false');
        var check = opt.querySelector('.sort-check');
        if (check) check.textContent = on ? '✓' : '';
      });
      var sheetSortLabel = document.querySelector('[data-sheet-sort-label]');
      if (sheetSortLabel && label) sheetSortLabel.textContent = label;
      navigateWithSort(value);
    }

    function wireSortDropdown() {
      var sortDd = document.querySelector('[data-sort-dropdown]');
      var sortTrigger = document.getElementById('sortTrigger');
      var sortPanel = document.getElementById('sortPanel');
      if (!sortDd || !sortTrigger || !sortPanel) return;

      function setSortOpen(open) {
        var wasOpen = sortPanel.classList.contains('open');
        sortTrigger.classList.toggle('open', open);
        sortPanel.classList.toggle('open', open);
        sortTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (wasOpen && !open) updateFacetCounts();
      }

      document.addEventListener('click', function (e) {
        var opt = e.target.closest('.sort-option');
        if (opt && sortPanel.contains(opt)) {
          applySort(opt.dataset.sortValue, opt.querySelector('span') ? opt.querySelector('span').textContent.trim() : '');
          setSortOpen(false);
          return;
        }
        if (e.target.closest('#sortTrigger')) {
          setSortOpen(!sortPanel.classList.contains('open'));
          return;
        }
        if (!sortDd.contains(e.target)) setSortOpen(false);
      }, on);
    }

    function wireFilterSheet() {
      var sheet = document.getElementById('filterSheet');
      if (!sheet) return;

      function openSheet() {
        sheet.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var trigger = document.querySelector('[data-sheet-open]');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }
      function closeSheet() {
        sheet.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        var trigger = document.querySelector('[data-sheet-open]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        updateFacetCounts();   // rows held still while the sheet was open can now settle
      }

      function syncSheetOption(target, value, labelEl, labelText) {
        sheet.querySelectorAll('[data-sheet-target="' + target + '"]').forEach(function (btn) {
          btn.classList.toggle('active', btn.dataset.sheetFilter === value);
        });
        var panelId = target === 'color' ? 'filterPanel' : 'regionPanel';
        var valueId = target === 'color' ? 'filterValue' : 'regionValue';
        var dataAttr = target === 'color' ? 'filter' : 'region';
        var panel = document.getElementById(panelId);
        if (panel) {
          panel.querySelectorAll('.dd-option').forEach(function (opt) {
            opt.classList.toggle('active', (opt.dataset[dataAttr] || 'all') === value);
          });
          var activeOpt = panel.querySelector('.dd-option[data-' + dataAttr + '="' + value + '"]');
          var valueEl = document.getElementById(valueId);
          if (valueEl && activeOpt) {
            var clone = activeOpt.cloneNode(true);
            var countNode = clone.querySelector('.dd-count');
            if (countNode) countNode.remove();
            valueEl.textContent = clone.textContent.trim();
          }
        }
        if (labelEl && labelText) labelEl.textContent = labelText;
      }

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-sheet-open]')) {
          openSheet();
          return;
        }
        if (e.target.closest('[data-sheet-close]')) {
          closeSheet();
          return;
        }
        var sheetOpt = e.target.closest('[data-sheet-filter]');
        if (sheetOpt && sheet.contains(sheetOpt)) {
          if (sheetOpt.getAttribute('aria-disabled') === 'true') return;
          var target = sheetOpt.dataset.sheetTarget;
          var val = sheetOpt.dataset.sheetFilter;
          var label = sheetOpt.textContent.replace(/\s+\d+$/, '').trim();
          if (target === 'color') {
            state.color = val;
            syncSheetOption('color', val, document.querySelector('[data-sheet-color-label]'), label);
          } else if (target === 'region') {
            state.region = val;
            syncSheetOption('region', val, document.querySelector('[data-sheet-region-label]'), label);
          }
          applyClientFilters();
          return;
        }
        var sheetSort = e.target.closest('.sheet-sort-option');
        if (sheetSort && sheet.contains(sheetSort)) {
          var sortLabel = sheetSort.textContent.replace('✓', '').trim();
          applySort(sheetSort.dataset.sortValue, sortLabel);
          return;
        }
        if (e.target.closest('[data-sheet-clear]')) {
          state.color = 'all';
          state.region = 'all';
          state.type = 'all';
          syncSheetOption('color', 'all', document.querySelector('[data-sheet-color-label]'), null);
          syncSheetOption('region', 'all', document.querySelector('[data-sheet-region-label]'), null);
          applyClientFilters();
        }
      }, on);

      sheet.querySelectorAll('.sheet-acc-trigger').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          if (!panel) return;
          var open = trigger.getAttribute('aria-expanded') === 'true';
          trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) panel.setAttribute('hidden', '');
          else panel.removeAttribute('hidden');
        });
      });
    }

    wireSortDropdown();
    wireFilterSheet();

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      // Close any open dropdown, reset its trigger and bring focus back to it; close the phone sheet too.
      var closedAny = false;
      document.querySelectorAll('.dd-panel.open').forEach(function (p) {
        p.classList.remove('open');
        closedAny = true;
        var t = p.parentElement && p.parentElement.querySelector('.dd-trigger');
        if (!t) return;
        t.classList.remove('open');
        t.setAttribute('aria-expanded', 'false');
        if (p.contains(document.activeElement)) t.focus();
      });
      if (closedAny) updateFacetCounts();
      var sheetClose = document.querySelector('#filterSheet[aria-hidden="false"] .filter-sheet-close');
      if (sheetClose) sheetClose.click();
    }, on);

    function syncFilterUi() {
      function activate(panelId, attr, value) {
        var panel = document.getElementById(panelId);
        if (!panel) return;
        panel.querySelectorAll('.dd-option').forEach(function (opt) {
          var v = opt.getAttribute('data-' + attr) || opt.dataset[attr] || 'all';
          opt.classList.toggle('active', v === value);
        });
        var valueEl = document.getElementById(panelId === 'filterPanel' ? 'filterValue' : panelId === 'regionPanel' ? 'regionValue' : 'typeValue');
        var active = panel.querySelector('.dd-option.active');
        if (valueEl && active) {
          var clone = active.cloneNode(true);
          var countNode = clone.querySelector('.dd-count');
          if (countNode) countNode.remove();
          valueEl.textContent = clone.textContent.trim();
        }
      }
      activate('filterPanel', 'filter', state.color);
      activate('regionPanel', 'region', state.region);
      activate('typePanel', 'type', state.type);
      document.querySelectorAll('#chips .chip').forEach(function (chip) {
        chip.classList.toggle('active', (chip.dataset.filter || 'all') === state.type);
      });
    }
    // A filter in use (from the address bar, a shared link or Back) is never hidden, even before the counts arrive.
    function revealInUse() {
      [['color', 'filterPanel', 'filter', 'filterDropdown', 'sheetColorTrigger'],
       ['region', 'regionPanel', 'region', 'regionDropdown', 'sheetRegionTrigger']].forEach(function (t) {
        var v = state[t[0]];
        if (v === 'all' || !/^[a-z0-9-]+$/.test(v)) return;
        var dd = document.getElementById(t[3]);
        if (dd) dd.classList.remove('is-collapsed');
        var trig = document.getElementById(t[4]);
        var section = trig && trig.closest('.sheet-section');
        if (section) section.classList.remove('is-collapsed');
        document.querySelectorAll('#' + t[1] + ' .dd-option[data-' + t[2] + '="' + v + '"], .sheet-option[data-sheet-target="' + t[0] + '"][data-sheet-filter="' + v + '"]').forEach(function (o) {
          [o, o.closest('li')].forEach(function (el) { if (el) el.classList.remove('is-hidden', 'is-pending', 'is-zero'); });
        });
      });
      if (isFiltering()) {
        var mt = document.querySelector('.filter-mobile-trigger');
        if (mt) mt.classList.remove('is-collapsed');
      }
    }

    syncFilterUi();
    syncSheetUi();
    revealInUse();

    window.addEventListener('popstate', function () {
      syncStateFromUrl();
      revealInUse();
      syncFilterUi();
      syncSheetUi();
      suppressHistory = true;
      try { applyClientFilters(); } finally { suppressHistory = false; }
    }, on);

    (function syncSortUi() {
      var ui = uiFromSortParam(currentSort());
      var opt = document.querySelector('.sort-option[data-sort-value="' + ui + '"] span');
      var label = opt ? opt.textContent.trim() : '';
      var sortSelect = document.getElementById('collectionSort');
      var sortDisplay = document.querySelector('[data-sort-value-display]');
      if (sortSelect) sortSelect.value = ui;
      if (sortDisplay && label) sortDisplay.textContent = label;
      var sheetSortLabel = document.querySelector('[data-sheet-sort-label]');
      if (sheetSortLabel && label) sheetSortLabel.textContent = label;
      document.querySelectorAll('.sort-option, .sheet-sort-option').forEach(function (o) {
        var on = o.dataset.sortValue === ui;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        var check = o.querySelector('.sort-check');
        if (check) check.textContent = on ? '✓' : '';
      });
    })();

    if (isFiltering()) {
      applyClientFilters();
    } else {
      renderActiveFilters();
      updateActiveCount();
    }

    if (!hasClientFilters) {
      if (toolbar) toolbar.setAttribute('data-counts-exact', 'true');   // nothing to count, so nothing to wait for
      return;
    }
    loadFilterData().then(function (items) {
      facetItems = items;
      updateFacetCounts();
    }).catch(function () {
      // Feed unavailable: count from the collection's cards instead.
      loadAllCards().catch(function () {
        // Neither loaded: offer every filter rather than keep choices hidden on a guess from the first 50 bottles.
        document.querySelectorAll('[data-collapse-estimate]').forEach(function (el) { el.classList.remove('is-collapsed'); });
        document.querySelectorAll('.dd-option.is-pending, .sheet-options li.is-pending').forEach(function (el) {
          el.classList.remove('is-pending');
          var b = el.matches('li') ? el.querySelector('.sheet-option') : el;
          if (b) b.removeAttribute('aria-disabled');
        });
      });
    });
  }

  window.sortGrid = function (mode) {
    var sectionRoot = document.querySelector('[data-collection-section]');
    var collectionBase = (sectionRoot && sectionRoot.getAttribute('data-collection-url')) ||
      window.location.pathname.replace(/\/+$/, '');
    var params = new URLSearchParams(window.location.search);
    var sortMap = {
      'price-asc': 'price-ascending',
      'price-desc': 'price-descending',
      name: 'title-ascending',
      featured: 'manual'
    };
    var sort = sortMap[mode] || 'manual';
    var url = new URL(collectionBase, window.location.origin);
    if (sort && sort !== 'manual') url.searchParams.set('sort_by', sort);
    ['color', 'region', 'type'].forEach(function (key) {
      var v = params.get(key);
      if (v) url.searchParams.set(key, v);
    });
    window.location.href = url.pathname + url.search;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilters);
  } else {
    initCollectionFilters();
  }

  // Theme editor: the collection section is re-rendered after each edit; start the filters again on the new markup.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-collection-section]')) initCollectionFilters();
  });

  // Theme editor: selecting a filter block in the sidebar opens the dropdown holding its option.
  function blockPanel(e) {
    var el = e.target;
    var panel = el && el.closest && el.closest('#filterPanel, #typeNavPanel');
    if (!panel) return null;
    var dd = panel.closest('.dropdown');
    return { panel: panel, trigger: dd && dd.querySelector('.dd-trigger') };
  }
  document.addEventListener('shopify:block:select', function (e) {
    var t = blockPanel(e);
    if (!t) return;
    t.panel.classList.add('open');
    if (t.trigger) { t.trigger.classList.add('open'); t.trigger.setAttribute('aria-expanded', 'true'); }
    if (e.target.scrollIntoView) e.target.scrollIntoView({ block: 'nearest' });
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var t = blockPanel(e);
    if (!t) return;
    t.panel.classList.remove('open');
    if (t.trigger) { t.trigger.classList.remove('open'); t.trigger.setAttribute('aria-expanded', 'false'); }
  });
})();
